<template>
    <div>
        <template v-if="!showFullText">
            <p
                class="tw-relative tw-text-sm md:tw-text-base"
                :class="[textClasses, truncatedTextClasses]"
                v-html="truncatedText"
            ></p>
            <dk-button
                v-if="enableReadMore"
                variant="subtle"
                class="tw-relative md:tw-mt-2 !tw-px-0 tw-text-sm md:tw-text-base md:tw-leading-base tw-leading-sm"
                :class="buttonClasses"
                @click="toggleText()"
            >
                {{ readMoreString }}
            </dk-button>
        </template>
        <template v-else>
            <p :class="textClasses" v-html="text"></p>
            <dk-button
                variant="subtle"
                class="tw-relative md:tw-mt-2 !tw-px-0 tw-text-sm md:tw-text-base md:tw-leading-base tw-leading-sm"
                :class="buttonClasses"
                @click="toggleText()"
            >
                {{ readLessString }}
            </dk-button>
        </template>
    </div>
</template>

<script>
import DkButton from '@v4/common/components/atoms/DkButton.vue';

export default {
    name: 'DkReadMore',
    components: {
        DkButton,
    },
    props: {
        text: {
            type: String,
            required: true,
        },
        textClasses: {
            type: String,
            default: '',
        },
        buttonClasses: {
            type: String,
            default: '',
        },
        maxChars: {
            type: Number,
            required: true,
        },
        readMoreString: {
            type: String,
            default: 'Read more',
        },
        readLessString: {
            type: String,
            default: 'Read less',
        },
        isBackgroundGray: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showFullText: false,
        };
    },
    computed: {
        enableReadMore() {
            return this.text.length > this.maxChars;
        },
        truncatedText() {
            return this.text.substr(0, this.maxChars);
        },
        truncatedTextClasses() {
            if (!this.enableReadMore) {
                return '';
            }

            const gradientClass = this.isBackgroundGray ? 'before:tw-from-secondary-light' : 'before:tw-from-white';
            return `before:tw-content-[''] before:tw-absolute before:tw-bottom-0 before:tw-left-0 before:tw-w-full before:tw-h-12 before:tw-pointer-events-none before:tw-bg-gradient-to-t ${gradientClass}`;
        },
    },
    methods: {
        toggleText() {
            this.showFullText = !this.showFullText;
        },
    },
};
</script>

<style></style>
